import React from 'react';
import IconPicker from './IconPicker';

const ServiceEditor = ({ service, index, onUpdate, onDelete }) => {
    return (
        <div className="service-card">
            <div className="service-header">
                <div className="service-header-left">
                    <span className="drag-handle" title="Drag to reorder">⋮⋮</span>
                    <IconPicker
                        value={service.icon}
                        onChange={(icon) => onUpdate(index, 'icon', icon)}
                    />
                </div>
                <button
                    type="button"
                    className="btn-danger"
                    onClick={() => onDelete(index)}
                    title="Remove service"
                >
                    ✕ Remove
                </button>
            </div>

            <div className="service-body">
                <div className="form-group" style={{ marginBottom: 0 }}>
                    <input
                        type="text"
                        placeholder="Service Title *"
                        value={service.title}
                        onChange={(e) => onUpdate(index, 'title', e.target.value)}
                        maxLength={255}
                        className="form-input"
                    />
                </div>

                <div className="form-group" style={{ marginBottom: 0 }}>
                    <textarea
                        placeholder="Service Description (optional)"
                        value={service.description}
                        onChange={(e) => onUpdate(index, 'description', e.target.value)}
                        maxLength={500}
                        rows={3}
                        className="form-textarea"
                    />
                    <div className="char-counter">
                        {service.description?.length || 0}/500
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceEditor;
